<section class="contact">
    <h1 class="contact__title">{{ 'contact.title' | transloco }}</h1>
    <p class="contact__tagline">{{ 'contact.tagline' | transloco }}</p>

    <form class="contact__form" [formGroup]="form" (ngSubmit)="onSubmit()" novalidate>
        <h2 class="contact__form__title">{{ 'contact.formTitle' | transloco }}</h2>
        <p class="contact__form__hint">{{ 'contact.formHintBefore' | transloco }}<a href="#" (click)="openLegal($event)" class="contact__form__legal-link" [attr.aria-label]="'contact.formHintLegalAriaLabel' | transloco">{{ 'contact.formHintLegal' | transloco }}</a>{{ 'contact.formHintAfter' | transloco }}</p>

        <label class="contact__form__field">
            <span class="contact__form__label">{{ 'contact.labelName' | transloco }}</span>
            <input class="contact__form__input"
                   type="text"
                   formControlName="name"
                   autocomplete="name"
                   maxlength="200"
                   aria-required="true" />
            <span class="contact__form__error" *ngIf="form.get('name')?.touched && form.get('name')?.invalid">
                {{ 'contact.errorName' | transloco }}
            </span>
        </label>

        <label class="contact__form__field">
            <span class="contact__form__label">{{ 'contact.labelEmail' | transloco }}</span>
            <input class="contact__form__input"
                   type="email"
                   formControlName="email"
                   autocomplete="email"
                   maxlength="254"
                   aria-required="true" />
            <span class="contact__form__error" *ngIf="form.get('email')?.touched && form.get('email')?.invalid">
                {{ 'contact.errorEmail' | transloco }}
            </span>
        </label>

        <label class="contact__form__field">
            <span class="contact__form__label">{{ 'contact.labelMessage' | transloco }}</span>
            <textarea class="contact__form__textarea"
                      formControlName="message"
                      rows="6"
                      [attr.maxlength]="maxMessageLength"
                      aria-required="true"></textarea>
            <span class="contact__form__counter">{{ 'contact.counter' | transloco:{ current: messageLength, max: maxMessageLength } }}</span>
            <span class="contact__form__error" *ngIf="form.get('message')?.touched && form.get('message')?.invalid">
                {{ 'contact.errorMessage' | transloco:{ max: maxMessageLength } }}
            </span>
        </label>


        <!-- Honeypot: visually hidden; leave empty. Do not use type=hidden (bots skip those). -->
        <div class="contact__form__hp" aria-hidden="true">
            <label>
                <span>Website</span>
                <input type="text"
                       formControlName="website"
                       name="website"
                       tabindex="-1"
                       autocomplete="off" />
            </label>
        </div>

        <button type="submit"
                class="contact__form__btn"
                [disabled]="submitting || form.invalid">
            {{ submitting ? ('contact.submitSending' | transloco) : ('contact.submitSend' | transloco) }}
        </button>

        <p class="contact__form__success" *ngIf="successMessage" role="status">{{ successMessage }}</p>
        <p class="contact__form__error contact__form__error--global" *ngIf="errorMessage" role="alert">{{ errorMessage }}</p>
    </form>

    <div class="contact__how__to__contact">
        <div class="contact__how__to__contact__company left">
            <h3 class="contact__how__to__contact__company__title">{{ 'contact.companyTitle' | transloco }}</h3>
            <a [routerLink]="language.link(['how-we-can-help-you'])" class="contact__how__to__contact__company__link">{{ 'contact.howWeCanHelpYou' | transloco }}</a>
            <a [routerLink]="language.link(['what-do-we-do'])" class="contact__how__to__contact__company__link">{{ 'contact.whatDoWeDo' | transloco }}</a>
            <a [routerLink]="language.link(['who-do-we-work-for'])" class="contact__how__to__contact__company__link">{{ 'contact.whoDoWeWorkFor' | transloco }}</a>
            <a [routerLink]="language.link(['who-we-are', 1])" class="contact__how__to__contact__company__link">{{ 'contact.whoWeAre' | transloco }}</a>
        </div>
        <div class="contact__how__to__contact__contact center">
            <h3 class="contact__how__to__contact__contact__title">{{ 'contact.contactTitle' | transloco }}</h3>
            <a href="mailto:info@amvara.io" class="contact__how__to__contact__contact__mailto">{{ 'contact.email' | transloco }}</a>
            <a href="tel:+4971189467029" class="contact__how__to__contact__contact__phone" [attr.aria-label]="'contact.phoneAriaLabel' | transloco">{{ 'contact.phoneDe' | transloco }}</a>
            <br>
            <br>
            <a href="https://wa.me/34717102603" target="_blank" class="contact__how__to__contact__contact__phone link" [attr.aria-label]="'contact.whatsappAriaLabel' | transloco">{{ 'contact.phoneWhatsapp' | transloco }}</a>
            <div class="contact__how__to__contact__contact__social">
                <img onclick="window.open('https://www.linkedin.com/company/amvara')" src="assets/img/linked-in.svg" class="contact__how__to__contact__contact__social__icon" [attr.alt]="'common.followUsLinkedIn' | transloco" role="button" tabindex="0">
            </div>
            <div class="contact__how__to__contact__contact__social">
                <img onclick="window.open('https://discord.gg/jgkuZ6FatD')" src="assets/img/discord.png" style="width:32px; background-color:white" class="contact__how__to__contact__contact__social__icon" [attr.alt]="'common.contactUsDiscord' | transloco" role="button" tabindex="0">
            </div>
        </div>
        <div class="contact__how__to__contact__address right">
            <h3 class="contact__how__to__contact__address__title">{{ 'contact.addressTitle' | transloco }}</h3>
            <a class="contact__how__to__contact__address__a" href="https://www.google.es/maps/place/Gran+Via+de+les+Corts+Catalanes,+636,+08010+Barcelona/@41.3896301,2.1669692,17z/data=!3m1!4b1!4m5!3m4!1s0x12a4a2f21893fc83:0x515f2a3568c82114!8m2!3d41.3896261!4d2.1691632">
                <p class="contact__how__to__contact__address__address">{{ 'contact.addressLine1' | transloco }}</p>
                <p class="contact__how__to__contact__address__address">{{ 'contact.addressLine2' | transloco }}</p>
            </a>
        </div>
    </div>
</section>
